<template>
  <div>
    <el-dialog
        :visible.sync="departmentDialogVisible"
        title="Danh sách phòng ban"
        width="500px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        custom-class="sk-dialog"
        top="30vh">
      <div class="sk-dialog-content">
        <div class="sk-panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon"><i class="el-icon-s-home"></i></div>
            <div>
              <p class="sk-panel-title">Danh sách phòng ban</p>
              <p class="sk-panel-subtitle">Các phòng ban mà nhân viên này đang thuộc về.</p>
            </div>
          </div>
          <div v-if="selectedDepartmentList.length">
            <div v-for="(item, index) in selectedDepartmentList" :key="index" style="padding: 4px 0; border-bottom: 1px solid #f1f5f9; font-size: 14px; color: #334155;">
              <i class="el-icon-arrow-right" style="color: #78a5e7; margin-right: 6px;"></i>
              {{ item.department.departmentName }}
            </div>
          </div>
          <div v-else class="sk-note">
            <i class="el-icon-info"></i>
            <span>Nhân viên này chưa được phân công phòng ban nào.</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="sk-dialog-footer">
        <el-button class="btn-cancel" type="danger" @click="closeDialog">Đóng</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "InformationDepartmentByEmployeeDialog",
  props: {
    departmentDialogVisible: {
      Type: Boolean,
      default: () => false,
    },
    selectedDepartmentList: {
      Type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  methods: {
    closeDialog() {
      this.$emit("dialog-close");
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>